import React from 'react'
import { Icon } from 'antd'
import { Flex, WhiteSpace } from 'antd-mobile'
import classes from './styles.module.scss'
import { ReactComponent as DrawerCloseIcon } from './images/close.svg'

export function DrawerHeader({ onClickLeft, showLeft, onClickRight, title }) {
  return (

    <Flex align='center' alignContent='center'>
      <Flex.Item className={classes.drawerTitle}>
        {showLeft && <Icon className={classes.leftIcon} onClick={() => onClickLeft()} type='arrow-left' />}
        <Flex align='center' justify='center'>
          <span>{title}</span>
        </Flex>
        <Icon className={classes.rightIcon} onClick={onClickRight} component={DrawerCloseIcon} />
      </Flex.Item>
      <WhiteSpace size='xl' />
    </Flex>
  )
}
